import { z } from 'zod';

export const AuthIntentSchema = z.enum(['connect', 'reconnect']);

export const AuthUrlQuerySchema = z.object({
    intent: AuthIntentSchema.default('connect'),
});

export const AuthUrlResponseSchema = z.object({
    authUrl: z.string().url(),
});

export const AuthCallbackQuerySchema = z.object({
    code: z.string().min(1).optional(),
    error: z.string().min(1).optional(),
    state: z.string().min(1),
}).refine(
    ({ code, error }) => Boolean(code) !== Boolean(error),
    { message: 'OAuth callback must include exactly one of code or error' },
);

export const AuthStatusResponseSchema = z.object({
    gmailEmail: z.string().email().nullable(),
    isConnected: z.boolean(),
    /** True when currently granted Gmail OAuth scopes satisfy required app permissions */
    hasRequiredScopes: z.boolean(),
    /** OAuth scope URLs still missing from the current token grant */
    missingScopes: z.array(z.string()).default([]),
    /** True when refresh token is valid and access token can be silently refreshed */
    tokenHealthy: z.boolean(),
    /** When the refresh token expires (null if no token or unknown) */
    refreshTokenExpiresAt: z.string().datetime().nullable(),
    /** Banner state hint for Gmail recovery UI. */
    serviceState: z.enum(['ok', 'reconnect_required', 'service_unavailable']),
});

export type AuthIntent = z.infer<typeof AuthIntentSchema>;
export type AuthStatus = z.infer<typeof AuthStatusResponseSchema>;
